// extracted by mini-css-extract-plugin
export default {"main":"AddHospital_main__oGicJ","form":"AddHospital_form__aTg6X","btn":"AddHospital_btn__LB+76"};